module.exports = __webpack_public_path__ + "img/hambuger.1418fb4f.svg";